import React, { FC } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Crumb } from '../Breadcrumbs';

type UsersRouteParams = {
  userId?: string;
};

export const UsersCrumbs: FC<RouteComponentProps<UsersRouteParams>> = ({
  match,
}) => {
  const { userId } = match.params;
  const isCreatePage = match.url.includes('/create');

  return userId || isCreatePage ? (
    <Crumb>
      <Link to="/admin/all-users">Users</Link>
    </Crumb>
  ) : (
    <Crumb>Users</Crumb>
  );
};
